import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';
const FolderCardContent = ({ className, folder, folder: { subfolders, hasSubfolders: hasSubfoldersFromFolder = (()=>{
    var _subfolders;
    return !!((_subfolders = subfolders) === null || _subfolders === void 0 ? void 0 : _subfolders.length);
})(), type }, totalDeviationCount, hasSubfolders: hasSubfoldersOverride, isCurrentUserOwner, width, height })=>{
    var _folder_thumb;
    const { t } = useTranslation();
    const invisible_folders = useFlag('invisible_folders');
    const emptyGallectionInfo = {
        gallery: 'folderCard.empty.gallery.info',
        collection: 'folderCard.empty.collection.info'
    };
    const hasSubfolders = hasSubfoldersOverride !== null && hasSubfoldersOverride !== void 0 ? hasSubfoldersOverride : hasSubfoldersFromFolder;
    if (!width || !height) {
        return null;
    }
    if (!invisible_folders && totalDeviationCount === 0 && isCurrentUserOwner) {
        return /*#__PURE__*/ React.createElement("div", {
            className: folderCardStyles['empty-folder'],
            style: {
                width,
                height
            }
        }, /*#__PURE__*/ React.createElement(UnwatchIcon, {
            className: folderCardStyles['empty-icon'],
            size: IconSize.HUGE
        }), height > 120 && /*#__PURE__*/ React.createElement("div", {
            className: folderCardStyles['empty-folder-info']
        }, t(emptyGallectionInfo[type])));
    }
    const isPremiumFolder = normalizePremiumFolderData(folder.premiumFolderData).isPremium;
    const isFolderThumbPublished = folder.thumb && folder.thumb.isPublished;
    const showBlurredThumbInfoToOwner = isCurrentUserOwner && isPremiumFolder && isFolderThumbPublished && ((_folder_thumb = folder.thumb) === null || _folder_thumb === void 0 ? void 0 : _folder_thumb.premiumFolderData);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, hasSubfolders && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['subfolders-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, hasSubfolders && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
        className: classnames(folderCardStyles['subfolders-icon'])
    }))), /*#__PURE__*/ React.createElement(GallectionCoverDumbo, {
        width: width,
        height: height,
        gallection: folder
    }), showBlurredThumbInfoToOwner && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['info-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, /*#__PURE__*/ React.createElement(FolderCoverInfo, null))));
};
export default FolderCardContent;
